/**
 * 存在しないユーザーです
 */
export const USER_NOT_FOUND = '存在しないユーザーです';
/**
 * ネットワークエラーが発生しました
 */
export const NETWORK = 'ネットワークエラーが発生しました';
/**
 * 不明なエラーが発生しました
 */
export const UNKNWON = '不明なエラーが発生しました';
/**
 * 認証コードに間違いがあります
 */
export const FAILD_CODE = '認証コードに間違いがあります';
/**
 * 認証に失敗しました
 */
export const FAILD_CONFIRMED = '認証に失敗しました';
/**
 * 既に特権管理者もしくは管理者として登録済みのメールアドレスです
 */
export const EXISTED_EMAIL =
  '既に特権管理者もしくは管理者として登録済みのメールアドレスです';
/**
 * 入力されたメールアドレスは既にチーム内に存在します
 */
export const EXISTED_EMAIL_TEAM =
  '入力されたメールアドレスは既にチーム内に存在します';
/**
 * 入力された携帯番号は既にチーム内に存在します
 */
export const EXISTED_PHONE_NUMBER =
  '入力された携帯番号は既にチーム内に存在します';
/**
 * 認証済みです。ログインしてください
 */
export const EXISTED_CONFIRM_CODE = '認証済みです。ログインしてください';
/**
 * 既に登録済みのメールアドレスが存在します
 */
export const INCORRECT_AUTHENTICATION =
  '認証情報が正しくありません。もう一度試してください。';
/**
 * 無効なカードです。カード情報を変更してください
 */
export const INVALID_CARD = '無効なカードです。カード情報を変更してください';
